import { Link } from '@pets-ui/Link/Link'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  cartItemBadge: {
    padding: '0 2px',
    borderRadius: '99px',
    alignItems: 'center',
    backgroundColor: colors.red600,
    color: colors.white,
    display: 'flex',
    fontSize: 10,
    fontWeight: 'bold',
    justifyContent: 'center',
    lineHeight: '10px',
    pointerEvents: 'none',
    position: 'absolute',
    minHeight: 16,
    minWidth: 16,
    right: '-1px',
    top: '-1px',
  },
})

interface TheHeaderCartBadgeProps {
  totalQuantity: number
}

export function TheHeaderCartBadge(props: TheHeaderCartBadgeProps) {
  const { totalQuantity } = props

  if (totalQuantity === 0) return null
  return (
    <Link
      rootStyle={styles.cartItemBadge}
    >
      {totalQuantity}
    </Link>
  )
}
